import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Checkbox } from './luci-checkbox.model';

@Component({
  selector: 'luci-checkbox',
  templateUrl: './luci-checkbox.component.html',
  styleUrls: ['./luci-checkbox.component.scss']
})
export class LuciCheckboxComponent implements OnInit, OnChanges {

  @Input() count: Checkbox[];
  @Input() withLabel = true;
  @Input() checked = true;
  @Input() checkLabel = '';
  @Input() checkboxAlign = '';
  @Input() error = '';
  @Input() isDisabled = true;
  @Output() checkedItem: EventEmitter<any> = new EventEmitter();
  @Input() statusIcon = '';
  @Input() isMandatoryIcon = false;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {}

  checkItem(index) {
    this.count[index].checked = !this.count[index].checked;
    this.checkedItem.emit(this.count[index]);
  }

  getIcon() {
    return `assets/icons/luci.svg#${this.statusIcon}`;
  }

}
